(function () {
  'use strict';
  angular
    .module('frontendApp',
    ['ui.bootstrap',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'toastr',
      'LocalStorageModule',
       'satellizer',
      'sap.imageloader',
      'angular-inview',
      'ngMap',
      'fox.scrollReveal',
      'angularSmoothscroll',
      'angular-owl-carousel-2',
      'angular-loading-bar',
      'swipe',
      '720kb.socialshare'
      /*,
      'ngColorThief'*/
    ]);

})();

'use strict';
angular
  .module('frontendApp')
  .factory('ContentService', function ($http, $rootScope) {
    return {

      getdata: function (tabla, params) {
        //params['lan'] =   $rootScope.language;
        params['lan'] = 'es';
        return $http.post($rootScope.api + '/api/' + tabla + '/getdata', params);
      },

      webcontent: function (state, params) {
        //params['lan'] =   $rootScope.language;
        params['lan'] = $rootScope.language;
        params['state'] = state;
        return $http.post($rootScope.api + '/api/webcontent', params);
      },

      sendform: function (params) {
        return $http.post($rootScope.api + '/api/sendform', params);
      }


    };
  });

/**
 * Created by FER-PC-WIN10 on 03/05/2016.
 */
(function () {
  'use strict';
  angular
    .module('frontendApp')
    .directive('renderHtml', function ($compile) {
      return function (scope, element, attrs) {
        scope.$watch(
          function (scope) {
            return scope.$eval(attrs.renderHtml);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      };
    });
})();

/* -----------------------------------------------
 /* Author : Vincent Garreau  - vincentgarreau.com
 /* MIT license: http://opensource.org/licenses/MIT
 /* Demo / Generator : vincentgarreau.com/particles.js
 /* GitHub : github.com/VincentGarreau/particles.js
 /* How to use? : Check the GitHub README
 /* v2.0.0
 /* ----------------------------------------------- */
function hexToRgb(e) {
  var a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(a, function (e, a, t, i) {
    return a + a + t + t + i + i
  });
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16)} : null
}
function clamp(e, a, t) {
  return Math.min(Math.max(e, a), t)
}
function isInArray(e, a) {
  return a.indexOf(e) > -1
}
var pJS = function (e, a) {
  var t = document.querySelector("#" + e + " > .particles-js-canvas-el");
  this.pJS = {
    canvas: {el: t, w: t.offsetWidth, h: t.offsetHeight},
    particles: {
      number: {value: 400, density: {enable: !0, value_area: 800}},
      color: {value: "#fff"},
      shape: {
        type: "circle",
        stroke: {width: 0, color: "#ff0000"},
        polygon: {nb_sides: 5},
        image: {src: "", width: 100, height: 100}
      },
      opacity: {value: 1, random: !1, anim: {enable: !1, speed: 2, opacity_min: 0, sync: !1}},
      size: {value: 20, random: !1, anim: {enable: !1, speed: 20, size_min: 0, sync: !1}},
      line_linked: {enable: !0, distance: 100, color: "#fff", opacity: 1, width: 1},
      move: {
        enable: !0,
        speed: 2,
        direction: "none",
        random: !1,
        straight: !1,
        out_mode: "out",
        bounce: !1,
        attract: {enable: !1, rotateX: 3e3, rotateY: 3e3}
      },
      array: []
    },
    interactivity: {
      detect_on: "canvas",
      events: {onhover: {enable: !0, mode: "grab"}, onclick: {enable: !0, mode: "push"}, resize: !0},
      modes: {
        grab: {distance: 100, line_linked: {opacity: 1}},
        bubble: {distance: 200, size: 80, duration: .4},
        repulse: {distance: 200, duration: .4},
        push: {particles_nb: 4},
        remove: {particles_nb: 2}
      },
      mouse: {}
    },
    retina_detect: !1,
    fn: {interact: {}, modes: {}, vendors: {}},
    tmp: {}
  };
  var i = this.pJS;
  a && Object.deepExtend(i, a), i.tmp.obj = {
    size_value: i.particles.size.value,
    size_anim_speed: i.particles.size.anim.speed,
    move_speed: i.particles.move.speed,
    line_linked_distance: i.particles.line_linked.distance,
    line_linked_width: i.particles.line_linked.width,
    mode_grab_distance: i.interactivity.modes.grab.distance,
    mode_bubble_distance: i.interactivity.modes.bubble.distance,
    mode_bubble_size: i.interactivity.modes.bubble.size,
    mode_repulse_distance: i.interactivity.modes.repulse.distance
  }, i.fn.retinaInit = function () {
    i.retina_detect && window.devicePixelRatio > 1 ? (i.canvas.pxratio = window.devicePixelRatio, i.tmp.retina = !0) : (i.canvas.pxratio = 1, i.tmp.retina = !1), i.canvas.w = i.canvas.el.offsetWidth * i.canvas.pxratio, i.canvas.h = i.canvas.el.offsetHeight * i.canvas.pxratio, i.particles.size.value = i.tmp.obj.size_value * i.canvas.pxratio, i.particles.size.anim.speed = i.tmp.obj.size_anim_speed * i.canvas.pxratio, i.particles.move.speed = i.tmp.obj.move_speed * i.canvas.pxratio, i.particles.line_linked.distance = i.tmp.obj.line_linked_distance * i.canvas.pxratio, i.interactivity.modes.grab.distance = i.tmp.obj.mode_grab_distance * i.canvas.pxratio, i.interactivity.modes.bubble.distance = i.tmp.obj.mode_bubble_distance * i.canvas.pxratio, i.particles.line_linked.width = i.tmp.obj.line_linked_width * i.canvas.pxratio, i.interactivity.modes.bubble.size = i.tmp.obj.mode_bubble_size * i.canvas.pxratio, i.interactivity.modes.repulse.distance = i.tmp.obj.mode_repulse_distance * i.canvas.pxratio
  }, i.fn.canvasInit = function () {
    i.canvas.ctx = i.canvas.el.getContext("2d")
  }, i.fn.canvasSize = function () {
    i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i && i.interactivity.events.resize && window.addEventListener("resize", function () {
      i.canvas.w = i.canvas.el.offsetWidth, i.canvas.h = i.canvas.el.offsetHeight, i.tmp.retina && (i.canvas.w *= i.canvas.pxratio, i.canvas.h *= i.canvas.pxratio), i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i.particles.move.enable || (i.fn.particlesEmpty(), i.fn.particlesCreate(), i.fn.particlesDraw(), i.fn.vendors.densityAutoParticles()), i.fn.vendors.densityAutoParticles()
    })
  }, i.fn.canvasPaint = function () {
    i.canvas.ctx.fillRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.canvasClear = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.particle = function (e, a, t) {
    if (this.radius = (i.particles.size.random ? Math.random() : 1) * i.particles.size.value, i.particles.size.anim.enable && (this.size_status = !1, this.vs = i.particles.size.anim.speed / 100, i.particles.size.anim.sync || (this.vs = this.vs * Math.random())), this.x = t ? t.x : Math.random() * i.canvas.w, this.y = t ? t.y : Math.random() * i.canvas.h, this.x > i.canvas.w - 2 * this.radius ? this.x = this.x - this.radius : this.x < 2 * this.radius && (this.x = this.x + this.radius), this.y > i.canvas.h - 2 * this.radius ? this.y = this.y - this.radius : this.y < 2 * this.radius && (this.y = this.y + this.radius), i.particles.move.bounce && i.fn.vendors.checkOverlap(this, t), this.color = {}, "object" == typeof e.value)if (e.value instanceof Array) {
      var s = e.value[Math.floor(Math.random() * i.particles.color.value.length)];
      this.color.rgb = hexToRgb(s)
    } else void 0 != e.value.r && void 0 != e.value.g && void 0 != e.value.b && (this.color.rgb = {
      r: e.value.r,
      g: e.value.g,
      b: e.value.b
    }), void 0 != e.value.h && void 0 != e.value.s && void 0 != e.value.l && (this.color.hsl = {
      h: e.value.h,
      s: e.value.s,
      l: e.value.l
    }); else"random" == e.value ? this.color.rgb = {
      r: Math.floor(256 * Math.random()) + 0,
      g: Math.floor(256 * Math.random()) + 0,
      b: Math.floor(256 * Math.random()) + 0
    } : "string" == typeof e.value && (this.color = e, this.color.rgb = hexToRgb(this.color.value));
    this.opacity = (i.particles.opacity.random ? Math.random() : 1) * i.particles.opacity.value, i.particles.opacity.anim.enable && (this.opacity_status = !1, this.vo = i.particles.opacity.anim.speed / 100, i.particles.opacity.anim.sync || (this.vo = this.vo * Math.random()));
    var n = {};
    switch (i.particles.move.direction) {
      case"top":
        n = {x: 0, y: -1};
        break;
      case"top-right":
        n = {x: .5, y: -.5};
        break;
      case"right":
        n = {x: 1, y: -0};
        break;
      case"bottom-right":
        n = {x: .5, y: .5};
        break;
      case"bottom":
        n = {x: 0, y: 1};
        break;
      case"bottom-left":
        n = {x: -.5, y: 1};
        break;
      case"left":
        n = {x: -1, y: 0};
        break;
      case"top-left":
        n = {x: -.5, y: -.5};
        break;
      default:
        n = {x: 0, y: 0}
    }
    i.particles.move.straight ? (this.vx = n.x, this.vy = n.y, i.particles.move.random && (this.vx = this.vx * Math.random(), this.vy = this.vy * Math.random())) : (this.vx = n.x + Math.random() - .5, this.vy = n.y + Math.random() - .5), this.vx_i = this.vx, this.vy_i = this.vy;
    var r = i.particles.shape.type;
    if ("object" == typeof r) {
      if (r instanceof Array) {
        var c = r[Math.floor(Math.random() * r.length)];
        this.shape = c
      }
    } else this.shape = r;
    if ("image" == this.shape) {
      var o = i.particles.shape;
      this.img = {
        src: o.image.src,
        ratio: o.image.width / o.image.height
      }, this.img.ratio || (this.img.ratio = 1), "svg" == i.tmp.img_type && void 0 != i.tmp.source_svg && (i.fn.vendors.createSvgImg(this), i.tmp.pushing && (this.img.loaded = !1))
    }
  }, i.fn.particle.prototype.draw = function () {
    function e() {
      i.canvas.ctx.drawImage(r, a.x - t, a.y - t, 2 * t, 2 * t / a.img.ratio)
    }

    var a = this;
    if (void 0 != a.radius_bubble)var t = a.radius_bubble; else var t = a.radius;
    if (void 0 != a.opacity_bubble)var s = a.opacity_bubble; else var s = a.opacity;
    if (a.color.rgb)var n = "rgba(" + a.color.rgb.r + "," + a.color.rgb.g + "," + a.color.rgb.b + "," + s + ")"; else var n = "hsla(" + a.color.hsl.h + "," + a.color.hsl.s + "%," + a.color.hsl.l + "%," + s + ")";
    switch (i.canvas.ctx.fillStyle = n, i.canvas.ctx.beginPath(), a.shape) {
      case"circle":
        i.canvas.ctx.arc(a.x, a.y, t, 0, 2 * Math.PI, !1);
        break;
      case"edge":
        i.canvas.ctx.rect(a.x - t, a.y - t, 2 * t, 2 * t);
        break;
      case"triangle":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t, a.y + t / 1.66, 2 * t, 3, 2);
        break;
      case"polygon":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t / (i.particles.shape.polygon.nb_sides / 3.5), a.y - t / .76, 2.66 * t / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 1);
        break;
      case"star":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - 2 * t / (i.particles.shape.polygon.nb_sides / 4), a.y - t / 1.52, 2 * t * 2.66 / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 2);
        break;
      case"image":
        if ("svg" == i.tmp.img_type)var r = a.img.obj; else var r = i.tmp.img_obj;
        r && e()
    }
    i.canvas.ctx.closePath(), i.particles.shape.stroke.width > 0 && (i.canvas.ctx.strokeStyle = i.particles.shape.stroke.color, i.canvas.ctx.lineWidth = i.particles.shape.stroke.width, i.canvas.ctx.stroke()), i.canvas.ctx.fill()
  }, i.fn.particlesCreate = function () {
    for (var e = 0; e < i.particles.number.value; e++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value))
  }, i.fn.particlesUpdate = function () {
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      if (i.particles.move.enable) {
        var t = i.particles.move.speed / 2;
        a.x += a.vx * t, a.y += a.vy * t
      }
      if (i.particles.opacity.anim.enable && (1 == a.opacity_status ? (a.opacity >= i.particles.opacity.value && (a.opacity_status = !1), a.opacity += a.vo) : (a.opacity <= i.particles.opacity.anim.opacity_min && (a.opacity_status = !0), a.opacity -= a.vo), a.opacity < 0 && (a.opacity = 0)), i.particles.size.anim.enable && (1 == a.size_status ? (a.radius >= i.particles.size.value && (a.size_status = !1), a.radius += a.vs) : (a.radius <= i.particles.size.anim.size_min && (a.size_status = !0), a.radius -= a.vs), a.radius < 0 && (a.radius = 0)), "bounce" == i.particles.move.out_mode)var s = {
        x_left: a.radius,
        x_right: i.canvas.w,
        y_top: a.radius,
        y_bottom: i.canvas.h
      }; else var s = {
        x_left: -a.radius,
        x_right: i.canvas.w + a.radius,
        y_top: -a.radius,
        y_bottom: i.canvas.h + a.radius
      };
      switch (a.x - a.radius > i.canvas.w ? (a.x = s.x_left, a.y = Math.random() * i.canvas.h) : a.x + a.radius < 0 && (a.x = s.x_right, a.y = Math.random() * i.canvas.h), a.y - a.radius > i.canvas.h ? (a.y = s.y_top, a.x = Math.random() * i.canvas.w) : a.y + a.radius < 0 && (a.y = s.y_bottom, a.x = Math.random() * i.canvas.w), i.particles.move.out_mode) {
        case"bounce":
          a.x + a.radius > i.canvas.w ? a.vx = -a.vx : a.x - a.radius < 0 && (a.vx = -a.vx), a.y + a.radius > i.canvas.h ? a.vy = -a.vy : a.y - a.radius < 0 && (a.vy = -a.vy)
      }
      if (isInArray("grab", i.interactivity.events.onhover.mode) && i.fn.modes.grabParticle(a), (isInArray("bubble", i.interactivity.events.onhover.mode) || isInArray("bubble", i.interactivity.events.onclick.mode)) && i.fn.modes.bubbleParticle(a), (isInArray("repulse", i.interactivity.events.onhover.mode) || isInArray("repulse", i.interactivity.events.onclick.mode)) && i.fn.modes.repulseParticle(a), i.particles.line_linked.enable || i.particles.move.attract.enable)for (var n = e + 1; n < i.particles.array.length; n++) {
        var r = i.particles.array[n];
        i.particles.line_linked.enable && i.fn.interact.linkParticles(a, r), i.particles.move.attract.enable && i.fn.interact.attractParticles(a, r), i.particles.move.bounce && i.fn.interact.bounceParticles(a, r)
      }
    }
  }, i.fn.particlesDraw = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h), i.fn.particlesUpdate();
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      a.draw()
    }
  }, i.fn.particlesEmpty = function () {
    i.particles.array = []
  }, i.fn.particlesRefresh = function () {
    cancelRequestAnimFrame(i.fn.checkAnimFrame), cancelRequestAnimFrame(i.fn.drawAnimFrame), i.tmp.source_svg = void 0, i.tmp.img_obj = void 0, i.tmp.count_svg = 0, i.fn.particlesEmpty(), i.fn.canvasClear(), i.fn.vendors.start()
  }, i.fn.interact.linkParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = i.particles.line_linked.opacity - n / (1 / i.particles.line_linked.opacity) / i.particles.line_linked.distance;
      if (r > 0) {
        var c = i.particles.line_linked.color_rgb_line;
        i.canvas.ctx.strokeStyle = "rgba(" + c.r + "," + c.g + "," + c.b + "," + r + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(a.x, a.y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
      }
    }
  }, i.fn.interact.attractParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = t / (1e3 * i.particles.move.attract.rotateX), c = s / (1e3 * i.particles.move.attract.rotateY);
      e.vx -= r, e.vy -= c, a.vx += r, a.vy += c
    }
  }, i.fn.interact.bounceParticles = function (e, a) {
    var t = e.x - a.x, i = e.y - a.y, s = Math.sqrt(t * t + i * i), n = e.radius + a.radius;
    n >= s && (e.vx = -e.vx, e.vy = -e.vy, a.vx = -a.vx, a.vy = -a.vy)
  }, i.fn.modes.pushParticles = function (e, a) {
    i.tmp.pushing = !0;
    for (var t = 0; e > t; t++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value, {
      x: a ? a.pos_x : Math.random() * i.canvas.w,
      y: a ? a.pos_y : Math.random() * i.canvas.h
    })), t == e - 1 && (i.particles.move.enable || i.fn.particlesDraw(), i.tmp.pushing = !1)
  }, i.fn.modes.removeParticles = function (e) {
    i.particles.array.splice(0, e), i.particles.move.enable || i.fn.particlesDraw()
  }, i.fn.modes.bubbleParticle = function (e) {
    function a() {
      e.opacity_bubble = e.opacity, e.radius_bubble = e.radius
    }

    function t(a, t, s, n, c) {
      if (a != t)if (i.tmp.bubble_duration_end) {
        if (void 0 != s) {
          var o = n - p * (n - a) / i.interactivity.modes.bubble.duration, l = a - o;
          d = a + l, "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else if (r <= i.interactivity.modes.bubble.distance) {
        if (void 0 != s)var v = s; else var v = n;
        if (v != a) {
          var d = n - p * (n - a) / i.interactivity.modes.bubble.duration;
          "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else"size" == c && (e.radius_bubble = void 0), "opacity" == c && (e.opacity_bubble = void 0)
    }

    if (i.interactivity.events.onhover.enable && isInArray("bubble", i.interactivity.events.onhover.mode)) {
      var s = e.x - i.interactivity.mouse.pos_x, n = e.y - i.interactivity.mouse.pos_y, r = Math.sqrt(s * s + n * n), c = 1 - r / i.interactivity.modes.bubble.distance;
      if (r <= i.interactivity.modes.bubble.distance) {
        if (c >= 0 && "mousemove" == i.interactivity.status) {
          if (i.interactivity.modes.bubble.size != i.particles.size.value)if (i.interactivity.modes.bubble.size > i.particles.size.value) {
            var o = e.radius + i.interactivity.modes.bubble.size * c;
            o >= 0 && (e.radius_bubble = o)
          } else {
            var l = e.radius - i.interactivity.modes.bubble.size, o = e.radius - l * c;
            o > 0 ? e.radius_bubble = o : e.radius_bubble = 0
          }
          if (i.interactivity.modes.bubble.opacity != i.particles.opacity.value)if (i.interactivity.modes.bubble.opacity > i.particles.opacity.value) {
            var v = i.interactivity.modes.bubble.opacity * c;
            v > e.opacity && v <= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          } else {
            var v = e.opacity - (i.particles.opacity.value - i.interactivity.modes.bubble.opacity) * c;
            v < e.opacity && v >= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          }
        }
      } else a();
      "mouseleave" == i.interactivity.status && a()
    } else if (i.interactivity.events.onclick.enable && isInArray("bubble", i.interactivity.events.onclick.mode)) {
      if (i.tmp.bubble_clicking) {
        var s = e.x - i.interactivity.mouse.click_pos_x, n = e.y - i.interactivity.mouse.click_pos_y, r = Math.sqrt(s * s + n * n), p = ((new Date).getTime() - i.interactivity.mouse.click_time) / 1e3;
        p > i.interactivity.modes.bubble.duration && (i.tmp.bubble_duration_end = !0), p > 2 * i.interactivity.modes.bubble.duration && (i.tmp.bubble_clicking = !1, i.tmp.bubble_duration_end = !1)
      }
      i.tmp.bubble_clicking && (t(i.interactivity.modes.bubble.size, i.particles.size.value, e.radius_bubble, e.radius, "size"), t(i.interactivity.modes.bubble.opacity, i.particles.opacity.value, e.opacity_bubble, e.opacity, "opacity"))
    }
  }, i.fn.modes.repulseParticle = function (e) {
    function a() {
      var a = Math.atan2(d, p);
      if (e.vx = u * Math.cos(a), e.vy = u * Math.sin(a), "bounce" == i.particles.move.out_mode) {
        var t = {x: e.x + e.vx, y: e.y + e.vy};
        t.x + e.radius > i.canvas.w ? e.vx = -e.vx : t.x - e.radius < 0 && (e.vx = -e.vx), t.y + e.radius > i.canvas.h ? e.vy = -e.vy : t.y - e.radius < 0 && (e.vy = -e.vy)
      }
    }

    if (i.interactivity.events.onhover.enable && isInArray("repulse", i.interactivity.events.onhover.mode) && "mousemove" == i.interactivity.status) {
      var t = e.x - i.interactivity.mouse.pos_x, s = e.y - i.interactivity.mouse.pos_y, n = Math.sqrt(t * t + s * s), r = {
        x: t / n,
        y: s / n
      }, c = i.interactivity.modes.repulse.distance, o = 100, l = clamp(1 / c * (-1 * Math.pow(n / c, 2) + 1) * c * o, 0, 50), v = {
        x: e.x + r.x * l,
        y: e.y + r.y * l
      };
      "bounce" == i.particles.move.out_mode ? (v.x - e.radius > 0 && v.x + e.radius < i.canvas.w && (e.x = v.x), v.y - e.radius > 0 && v.y + e.radius < i.canvas.h && (e.y = v.y)) : (e.x = v.x, e.y = v.y)
    } else if (i.interactivity.events.onclick.enable && isInArray("repulse", i.interactivity.events.onclick.mode))if (i.tmp.repulse_finish || (i.tmp.repulse_count++, i.tmp.repulse_count == i.particles.array.length && (i.tmp.repulse_finish = !0)), i.tmp.repulse_clicking) {
      var c = Math.pow(i.interactivity.modes.repulse.distance / 6, 3), p = i.interactivity.mouse.click_pos_x - e.x, d = i.interactivity.mouse.click_pos_y - e.y, m = p * p + d * d, u = -c / m * 1;
      c >= m && a()
    } else 0 == i.tmp.repulse_clicking && (e.vx = e.vx_i, e.vy = e.vy_i)
  }, i.fn.modes.grabParticle = function (e) {
    if (i.interactivity.events.onhover.enable && "mousemove" == i.interactivity.status) {
      var a = e.x - i.interactivity.mouse.pos_x, t = e.y - i.interactivity.mouse.pos_y, s = Math.sqrt(a * a + t * t);
      if (s <= i.interactivity.modes.grab.distance) {
        var n = i.interactivity.modes.grab.line_linked.opacity - s / (1 / i.interactivity.modes.grab.line_linked.opacity) / i.interactivity.modes.grab.distance;
        if (n > 0) {
          var r = i.particles.line_linked.color_rgb_line;
          i.canvas.ctx.strokeStyle = "rgba(" + r.r + "," + r.g + "," + r.b + "," + n + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(i.interactivity.mouse.pos_x, i.interactivity.mouse.pos_y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
        }
      }
    }
  }, i.fn.vendors.eventsListeners = function () {
    "window" == i.interactivity.detect_on ? i.interactivity.el = window : i.interactivity.el = i.canvas.el, (i.interactivity.events.onhover.enable || i.interactivity.events.onclick.enable) && (i.interactivity.el.addEventListener("mousemove", function (e) {
      if (i.interactivity.el == window)var a = e.clientX, t = e.clientY; else var a = e.offsetX || e.clientX, t = e.offsetY || e.clientY;
      i.interactivity.mouse.pos_x = a, i.interactivity.mouse.pos_y = t, i.tmp.retina && (i.interactivity.mouse.pos_x *= i.canvas.pxratio, i.interactivity.mouse.pos_y *= i.canvas.pxratio), i.interactivity.status = "mousemove"
    }), i.interactivity.el.addEventListener("mouseleave", function (e) {
      i.interactivity.mouse.pos_x = null, i.interactivity.mouse.pos_y = null, i.interactivity.status = "mouseleave"
    })), i.interactivity.events.onclick.enable && i.interactivity.el.addEventListener("click", function () {
      if (i.interactivity.mouse.click_pos_x = i.interactivity.mouse.pos_x, i.interactivity.mouse.click_pos_y = i.interactivity.mouse.pos_y, i.interactivity.mouse.click_time = (new Date).getTime(), i.interactivity.events.onclick.enable)switch (i.interactivity.events.onclick.mode) {
        case"push":
          i.particles.move.enable ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : 1 == i.interactivity.modes.push.particles_nb ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : i.interactivity.modes.push.particles_nb > 1 && i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb);
          break;
        case"remove":
          i.fn.modes.removeParticles(i.interactivity.modes.remove.particles_nb);
          break;
        case"bubble":
          i.tmp.bubble_clicking = !0;
          break;
        case"repulse":
          i.tmp.repulse_clicking = !0, i.tmp.repulse_count = 0, i.tmp.repulse_finish = !1, setTimeout(function () {
            i.tmp.repulse_clicking = !1
          }, 1e3 * i.interactivity.modes.repulse.duration)
      }
    })
  }, i.fn.vendors.densityAutoParticles = function () {
    if (i.particles.number.density.enable) {
      var e = i.canvas.el.width * i.canvas.el.height / 1e3;
      i.tmp.retina && (e /= 2 * i.canvas.pxratio);
      var a = e * i.particles.number.value / i.particles.number.density.value_area, t = i.particles.array.length - a;
      0 > t ? i.fn.modes.pushParticles(Math.abs(t)) : i.fn.modes.removeParticles(t)
    }
  }, i.fn.vendors.checkOverlap = function (e, a) {
    for (var t = 0; t < i.particles.array.length; t++) {
      var s = i.particles.array[t], n = e.x - s.x, r = e.y - s.y, c = Math.sqrt(n * n + r * r);
      c <= e.radius + s.radius && (e.x = a ? a.x : Math.random() * i.canvas.w, e.y = a ? a.y : Math.random() * i.canvas.h, i.fn.vendors.checkOverlap(e))
    }
  }, i.fn.vendors.createSvgImg = function (e) {
    var a = i.tmp.source_svg, t = /#([0-9A-F]{3,6})/gi, s = a.replace(t, function (a, t, i, s) {
      if (e.color.rgb)var n = "rgba(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.opacity + ")"; else var n = "hsla(" + e.color.hsl.h + "," + e.color.hsl.s + "%," + e.color.hsl.l + "%," + e.opacity + ")";
      return n
    }), n = new Blob([s], {type: "image/svg+xml;charset=utf-8"}), r = window.URL || window.webkitURL || window, c = r.createObjectURL(n), o = new Image;
    o.addEventListener("load", function () {
      e.img.obj = o, e.img.loaded = !0, r.revokeObjectURL(c), i.tmp.count_svg++
    }), o.src = c
  }, i.fn.vendors.destroypJS = function () {
    cancelAnimationFrame(i.fn.drawAnimFrame), t.remove(), pJSDom = null
  }, i.fn.vendors.drawShape = function (e, a, t, i, s, n) {
    var r = s * n, c = s / n, o = 180 * (c - 2) / c, l = Math.PI - Math.PI * o / 180;
    e.save(), e.beginPath(), e.translate(a, t), e.moveTo(0, 0);
    for (var v = 0; r > v; v++)e.lineTo(i, 0), e.translate(i, 0), e.rotate(l);
    e.fill(), e.restore()
  }, i.fn.vendors.exportImg = function () {
    window.open(i.canvas.el.toDataURL("image/png"), "_blank")
  }, i.fn.vendors.loadImg = function (e) {
    if (i.tmp.img_error = void 0, "" != i.particles.shape.image.src)if ("svg" == e) {
      var a = new XMLHttpRequest;
      a.open("GET", i.particles.shape.image.src), a.onreadystatechange = function (e) {
        4 == a.readyState && (200 == a.status ? (i.tmp.source_svg = e.currentTarget.response, i.fn.vendors.checkBeforeDraw()) : (console.log("Error pJS - Image not found"), i.tmp.img_error = !0))
      }, a.send()
    } else {
      var t = new Image;
      t.addEventListener("load", function () {
        i.tmp.img_obj = t, i.fn.vendors.checkBeforeDraw()
      }), t.src = i.particles.shape.image.src
    } else console.log("Error pJS - No image.src"), i.tmp.img_error = !0
  }, i.fn.vendors.draw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type ? i.tmp.count_svg >= i.particles.number.value ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : void 0 != i.tmp.img_obj ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame))
  }, i.fn.vendors.checkBeforeDraw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type && void 0 == i.tmp.source_svg ? i.tmp.checkAnimFrame = requestAnimFrame(check) : (cancelRequestAnimFrame(i.tmp.checkAnimFrame), i.tmp.img_error || (i.fn.vendors.init(), i.fn.vendors.draw())) : (i.fn.vendors.init(), i.fn.vendors.draw())
  }, i.fn.vendors.init = function () {
    i.fn.retinaInit(), i.fn.canvasInit(), i.fn.canvasSize(), i.fn.canvasPaint(), i.fn.particlesCreate(), i.fn.vendors.densityAutoParticles(), i.particles.line_linked.color_rgb_line = hexToRgb(i.particles.line_linked.color)
  }, i.fn.vendors.start = function () {
    isInArray("image", i.particles.shape.type) ? (i.tmp.img_type = i.particles.shape.image.src.substr(i.particles.shape.image.src.length - 3), i.fn.vendors.loadImg(i.tmp.img_type)) : i.fn.vendors.checkBeforeDraw()
  }, i.fn.vendors.eventsListeners(), i.fn.vendors.start()
};
Object.deepExtend = function (e, a) {
  for (var t in a)a[t] && a[t].constructor && a[t].constructor === Object ? (e[t] = e[t] || {}, arguments.callee(e[t], a[t])) : e[t] = a[t];
  return e
}, window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e) {
      window.setTimeout(e, 1e3 / 60)
    }
}(), window.cancelRequestAnimFrame = function () {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout
}(), window.pJSDom = [], window.particlesJS = function (e, a) {
  "string" != typeof e && (a = e, e = "particles-js"), e || (e = "particles-js");
  var t = document.getElementById(e), i = "particles-js-canvas-el", s = t.getElementsByClassName(i);
  if (s.length)for (; s.length > 0;)t.removeChild(s[0]);
  var n = document.createElement("canvas");
  n.className = i, n.style.width = "100%", n.style.height = "100%";
  var r = document.getElementById(e).appendChild(n);
  null != r && pJSDom.push(new pJS(e, a))
}, window.particlesJS.load = function (e, a, t) {
  var i = new XMLHttpRequest;
  i.open("GET", a), i.onreadystatechange = function (a) {
    if (4 == i.readyState)if (200 == i.status) {
      var s = JSON.parse(a.currentTarget.response);
      window.particlesJS(e, s), t && t()
    } else console.log("Error pJS - XMLHttpRequest status: " + i.status), console.log("Error pJS - File config not found")
  }, i.send()
};
/**
 * Created by DELL on 18/7/2018.
 */

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //establece altura a pantalla completa
    .directive('loader', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()/2});
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            //console.log('exit')
          }).resize();
        }
      };
    })
    //carga video
    .directive('myYoutube', function ($sce) {
      return {
        restrict: 'A',
        scope: {code: '='},
        replace: true,
        template: '<div style="height:250px;"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
        link: function (scope) {
          //console.log('here');
          scope.$watch('code', function (newVal) {
            if (newVal) {
              scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + newVal);
            }
          });
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('equalheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@',
          full: '=',
        },
        link: function (scope, element) {
          $(window).resize(function () {
            console.log('targetclass',scope.targetclass);
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetHeight) {
                  temp = x[i].offsetHeight;
                }
              }
             /* if(scope.full){
                var customHeight = $(window).height();
                var temp2 =  customHeight>temp?customHeight:temp;
                console.log(customHeight,temp);
                element.css({minHeight: temp2});
              }*/
              //console.log('maximo altura detectada', temp);
              element.css({minHeight: temp});
            }, 1000);
          }).resize();
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('squareheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            //console.log(scope.targetclass)
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetWidth) {
                  temp = x[i].offsetWidth;
                }
              }
              //console.log('maximo altura detectada', temp);
              element.css({minHeight: temp});
            }, 1000);
          }).resize();
        }
      };
    })
    //establece una altura personalizada partiendo del alto de pantalla o deua medida especifica
    .directive('customheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '=',
          autoscroll: '=',
          lockscroll:'='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            if (scope.autoscroll == true) {
              element.css({maxHeight: customHeight});
              element.css({overflowY: 'scroll'});
            }
            element.css({minHeight: customHeight});
            if(scope.lockscroll==true){
              element.css({maxHeight: customHeight});
              element.css({overflow: 'hidden'});
            }
          }).resize();
        }
      };
    })
    //scroll control
    .directive('scroll', function () {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          elem.on('scroll', function (e) {
            console.log('detecta')
          });
        }
      };
    })
})();


(function () {
  'use strict';
  angular
    .module('frontendApp')
    .directive('particlesDrv', function ($window, $log)  {
      return {
        restrict: 'A',
        scope:{
          colorFill:'@',
        },
        template: '<div class="particles" id="particleJs"></div>',
        link: function(scope, element, attrs, fn) {
          console.log('test',scope.colorFill);
          $window.particlesJS('particleJs', {
            particles: {
              number: {
                value: 60,
                density: {
                  enable: true,
                  value_area: 800
                }
              },
              color: {
                //value: '#FFFFFF',
                value:'#1a3e67'
                //value:'#002d7a'
              },
              shape: {
                type: "circle",
                polygon: {
                  nb_sides: 5
                }
              },
              /*opacity: {
                value: 1,
                random: false,
                anim: {
                  enable: false,
                  speed: 1,
                  opacity_min: 0.1,
                  sync: false
                }
              },*/
              size: {
                value: 8,
                random: true,
                anim: {
                  enable: false,
                  speed: 40,
                  size_min: 0.9,
                  sync: false
                }
              },
              line_linked: {
                enable: true,
                distance: 150,
                color: '#ffffff',
                opacity: 0.2,
                /*color: '#0047ba',
                opacity: 1,*/
                width: 1
              },
              move: {
                enable: true,
                speed: 1.5,
                direction: 'none',
                random: false,
                straight: false,
                out_mode: 'out',
                bounce: false,
                attract: {
                  enable: false,
                  rotateX: 600,
                  rotateY: 1200
                }
              }
            },
            interactivity: {
              detect_on: 'canvas',
              events: {
                onhover: {
                  enable: false,
                  mode: 'grab'
                },
                onclick: {
                  enable: false,
                  mode: 'push'
                },
                resize: true
              },
              modes: {
                grab: {
                  distance: 140,
                  line_linked: {
                    opacity: 1
                  }
                },
                bubble: {
                  distance: 400,
                  size: 40,
                  duration: 2,
                  opacity: 8,
                  speed: 3
                },
                repulse: {
                  distance: 200,
                  duration: 0.4
                },
                push: {
                  particles_nb: 4
                },
                remove: {
                  particles_nb: 2
                }
              }
            },
            retina_detect: true
          });
        }
      };
    })
    .directive('particlesDrv2', function ($window, $log)  {
      return {
        restrict: 'A',
        scope:{
          colorFill:'@',
        },
        template: '<div class="particles" id="particleJs2"></div>',
        link: function(scope, element, attrs, fn) {
          console.log('test',scope.colorFill);

          $window.particlesJS('particleJs2', {
            particles: {
              number: {
                value: 60,
                density: {
                  enable: true,
                  value_area: 800
                }
              },
              color: {
                //value: '#FFFFFF',
                //value:'#1a3e67'
                value:'#33a1bb'
              },
              shape: {
                type: "circle",
                polygon: {
                  nb_sides: 5
                }
              },
              /*opacity: {
                value: 1,
                random: false,
                anim: {
                  enable: false,
                  speed: 1,
                  opacity_min: 0.1,
                  sync: false
                }
              },*/
              size: {
                value: 8,
                random: true,
                anim: {
                  enable: false,
                  speed: 40,
                  size_min: 0.9,
                  sync: false
                }
              },
              line_linked: {
                enable: true,
                distance: 150,
                color: '#ffffff',
                opacity: 0.2,
                width: 1
              },
              move: {
                enable: true,
                speed: 1.5,
                direction: 'none',
                random: false,
                straight: false,
                out_mode: 'out',
                bounce: false,
                attract: {
                  enable: false,
                  rotateX: 600,
                  rotateY: 1200
                }
              }
            },
            interactivity: {
              detect_on: 'canvas',
              events: {
                onhover: {
                  enable: true,
                  mode: 'grab'
                },
                onclick: {
                  enable: true,
                  mode: 'push'
                },
                resize: true
              },
              modes: {
                grab: {
                  distance: 140,
                  line_linked: {
                    opacity: 1
                  }
                },
                bubble: {
                  distance: 400,
                  size: 40,
                  duration: 2,
                  opacity: 8,
                  speed: 3
                },
                repulse: {
                  distance: 200,
                  duration: 0.4
                },
                push: {
                  particles_nb: 4
                },
                remove: {
                  particles_nb: 2
                }
              }
            },
            retina_detect: true
          });
        }
      };
    })
})();

angular
  .module('frontendApp')
  .controller('particlesCtrl', function ($rootScope, $scope) {
    //$scope.showParticles = true;
  });

'use strict';
angular
  .module('frontendApp')
  .controller('HomeController', function ( ImageLoader,$window,  $log, ContentService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('HomeController');

    var owlAPi;
    /*vm.items=[
      {
        id:1,
        contentEs:'<p><strong>Asesoramiento para el desarrollo de software a medida</strong> completamente adaptables a  cualquier tamaño de pantalla</p>',
        contentEn:'<p><strong>Advice for the development of custom software</strong> fully adaptable to any screen size</p>'
      },
      {
        id:2,
        contentEs:'<p><strong>Aplicaciones e innovaciones incrementales</strong> todos nuestros productos son completamente escalables y de facil ajuste a los objetivos empresariales</p>',
        contentEn:'<p><strong>Incremental applications and innovations</strong> all our products are completely scalable and easily adjusted to the business objective</p>'
      },
      {
        id:3,
        contentEs:'<p><strong>Productos completamente seguros</strong> para garantizar la integridad de la información</p>',
        contentEn:'<p><strong>Completely secure products</strong> to ensure the integrity of the information</p>'
      },
      {
        id:4,
        contentEs:'<p><strong>Generación de datos para las empresas</strong> con el fin de facilitar el análisis y toma de decisión</p>',
        contentEn:'<p><strong>Generation of data for companies</strong>  in order to facilitate analysis and decision making</p>'
      }
    ];*/
    /*vm.properties= {
      items: 1,
      nav:true,
      startPosition:0,
      //loop:true,
      //autoplay:true,
      scrollPerPage: true,
      navigation : true,
      singleItem : true,
      mouseDrag:false,
      /!*animateIn: 'fadeIn', // add this
      animateOut: 'fadeOut', // and this
      //animateIn: 'slideInDown', // add this
      //animateOut: 'slideOutDown', // and this*!/
      autoplayTimeout:4000,
      autoplaySpeed:4000,
      navText : ['<span class="arrow arrow-left" >1</span>','<span class="arrow arrow-right" >2</span>'],
    };*/
    vm.items = [0,1,2,3];
    vm.properties = {
      loop: true,
      items: 1,
      startPosition: 0,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      /*autoplaySpeed: 3000,*/
      nav: false,
      dots: true,
      onChange: function () {
        console.log('detecta cambio');
      }
    };
    vm.scrollEnable = true;
    var owl = $('.owl-carousel');
    owl.on('mousewheel', '.owl-stage', function (e) {
      console.log(e);
      if(vm.scrollEnable){
        if (e.originalEvent.deltaY>0) {
          owl.trigger('next.owl');
          vm.scrollEnable = false;
        } else {
          owl.trigger('prev.owl');
          vm.scrollEnable = false;
        }
        e.preventDefault();
        $timeout(function () {
          vm.scrollEnable = true;
        }, 1000);
      }


    });

    vm.swipeUp = function (){
      owl.trigger('prev.owl');
    };
    vm.swipeDown = function (){
      owl.trigger('next.owl');
    };
    $rootScope.sendMail = function(emailId,subject,message){
      $window.open("mailto:"+ emailId + "?subject=" + subject+"&body="+message,"_self");
    };

  })

;

'use strict';
angular
  .module('frontendApp')
  .controller('AppController', function ($state, $log, $rootScope, $scope,$timeout,toastr,
                                         ContentService) {
    var vm = this;
    $log.debug('AppController');
    $timeout(function () {
      $rootScope.particles = true;
    }, 500);


    $rootScope.innerview = false;
    $rootScope.showInner = function (i){
      $rootScope.innerview = !$rootScope.innerview;
      $rootScope.picked = i;
      console.log('picked',i);
    };
    $rootScope.$watch('innerview',function(){
      if ($rootScope.innerview == true ){
        document.body.style.overflow = 'hidden';
      }
      else{
        document.body.style.overflow = 'initial';
      }
    });
    $rootScope.copyToShare = function() {
      console.log('copy');
      var copyText = document.getElementById("myInput");
      copyText.select();
      document.execCommand("copy");
      toastr.success(copyText.value, 'Enlace copiado');
    };



    /////////////MODALS AND WEB FORMS///////////////

    $rootScope.modals = {
      currentModal:''
    };
    $rootScope.modalTab = 1 ;

    $rootScope.showModal = function (modal, value){
      console.log(modal);
      $rootScope.currentModal = modal;
      $rootScope.modals.currentModal = 'app/views/modals/'+modal+'.html';
      $rootScope.modalTab = 1 ;
      $rootScope.formData = {};
      $rootScope.generarSeguridad();
    };
    $rootScope.formDataHome = {};
    $rootScope.closeModal = function (){
      $rootScope.modals.currentModal = '';
      $rootScope.modalTab = 1 ;
    };

    $rootScope.navModals = function (value){
      switch(value){
        case 'prev':
          if($rootScope.modalTab>1){
            $rootScope.modalTab--;
          }
          break;
        case 'next':
          $rootScope.modalTab++;
          $timeout(function () {
            if($rootScope.currentModal!='modalpresskit' ){
              $rootScope.closeModal();
            }
          }, 5000);
          break;
        default:
          $rootScope.modalTab = value;
          break;
      }
    };

    $rootScope.$watch('modals', function () {
      console.log('actualiza modals',$rootScope.modals )
    }, true);
    function onloadCallback() {
      /*grecaptcha.ready(function() {
        grecaptcha.execute('6Lea5pcUAAAAAESSNlMhVPVx-roOJkt5emuiOeAI', {action: 'webform'})
          .then(function(token) {
            console.log('tc');
            $rootScope.gc = token;
          });
      });*/
    }
    //recaptcha
    $rootScope.generarSeguridad = function () {
      onloadCallback();
    };

    $rootScope.sendForm = function (id, data, flash){
      console.log('ingresa', id, data);
      if(id && data){
        console.log('ingresa 0');

        var params = {
          mailingcategory_id:id,
          gc:$rootScope.gc,
          fields: data
        };
        console.log('params', params);
        ContentService.sendform(params)
          .success(function (res) {
            console.log('sendform res', res);
            if (res.status) {
              $rootScope.navModals('next');
              console.log('sendform', res)
            }
            else{
              toastr.warning('Please try again','Connection error');
            }
          });
      }
      else{
        console.log('ingresa 1');
        $rootScope.navModals('next');
      }
      if(flash){
        toastr.success($rootScope.sT('Mensaje enviado', 'Message sent'), 'Success');
      }

    };


  });

(function() {
  'use strict';

  angular
      .module('frontendApp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontendApp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, ContentService,
                    ImageLoader,
                    $anchorScroll, $location,
                    localStorageService, $timeout, $window, $stateParams) {

    //REST API ROUTE
    //$rootScope.api = 'http://localhost:8000';
    $rootScope.api = 'http://techwise-admin.aknatechnologies.com/restapi/public';
    //$rootScope.api = 'https://admin.techwise.com.bo/restapi/public';
    //$rootScope.api = 'http://www.gustu.bo/restapi/public';

    //SESSION VARS MANIPULATION
    $rootScope.getSessionParam = function (key) {
      return localStorageService.get(key);
    };


    console.log('MARK STATE PARAMS', $stateParams.lan);

    $rootScope.setSessionParam = function (key, val) {
      return localStorageService.set(key, val);
    };
    // SETTING SPANISH AS DEFAULT LANGUAGE
    if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
      $rootScope.language = $stateParams.lan;
    }
    else {
      $rootScope.language = 'es';
      // $state.go('home', {lan: 'es'}, {reload: true});
    }
    //VERIFY CURRENT LANGUAGE
    $timeout(function () {
      if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        $rootScope.changeLanguage($stateParams.lan, $rootScope.currentState);
      }
      else {
        $rootScope.language = 'es';
        //$state.go('home', {lan: 'es'}, {reload: true});
      }
    }, 2);
    //TRANSALATE
    $rootScope.transl = function (target) {
      if(target){
        return target[$rootScope.language];
      }
      else{
        return '';
      }

    };

    $rootScope.sT = function (value1, value2) {
      if ($rootScope.language == 'es') {
        return value1;
      }
      else {
        return value2;
      }
    };

    //CHANGE OF ROUTE SETTING A NEW LANGUAGE
    $rootScope.changeLanguage = function (value, state) {
      $rootScope.language = value;
      $rootScope.setSessionParam('language', value);
      $state.go(state, {lan: value});
      delete $rootScope.wc;
    };

    //MAIL TO FUNCTION
    $rootScope.sendMail = function (emailId, subject, message) {
      $window.open("mailto:" + emailId + "?subject=" + subject + "&body=" + message, "_self");
    };

    //EXECUTE ON ROUTE CHANGE
    $rootScope.getCurrentSection = function(search){
      // console.log('buscando seccion actual');
      angular.forEach($rootScope.wcdata.Webroute, function(i){
        if(i.state == search){
          $rootScope.wc = i;
        }
      });
      // CUSTOM TECHWISE SINGLE PAGE
      angular.forEach($rootScope.wc.websection, function(val, key){

        switch(key){
          case 0:
            val.class = 'slideInDown';
            val.delay = '0.2s';

          break;
          case 1:
            val.class = 'slideInDown';
            val.delay = '0.3s';
          break;
          case 2:
            val.class = 'slideInRight';
            val.delay = '0.4s';
          break;
          case 3:
            val.class = 'slideInLeft';
            val.delay = '0.3s';
          break;
          case 4:
            val.class = 'slideInUp';
            val.delay = '0.4s';
          break;
          case 5:
            val.class = 'slideInUp';
            val.delay = '0.3s';
          break;
        }
        val.urlshare = 'https://www.techwise.com.bo/'+$rootScope.language+'/home/'+$rootScope.transl(val.title1);
        val.tags = $rootScope.transl(val.title1);
        val.tags = val.tags.replace(' ','');
      });
      if ($stateParams.sec) {
        console.log('$stateParams.sec',$stateParams.sec);

        angular.forEach($rootScope.wc.websection, function(val, key){
          console.log('section', $rootScope.transl(val.title1));
          var temp = ''+$stateParams.sec;
          var subsec = temp.toLowerCase();
          var title = $rootScope.transl(val.title1);
          if(subsec == title.toLowerCase()){
            $timeout(function () {
              $rootScope.showInner(val);
            }, 2000);
          }
        })
      }
      // CUSTOM TECHWISE SINGLE PAGE

      console.log('actual', $rootScope.wc );
    };


    $rootScope.encodeName = function (value) {
      return encodeURI(value);
    };

    //CHANGE ROUTE
    $rootScope.stateGo = function (state, sec) {
      $state.go(state, {
          lan: $rootScope.language
         // sec: sec ? sec : null
        }
      );
      $rootScope.scroller(sec);
    };

    $rootScope.scroller = function (sec) {
      /*if ($stateParams.sec && $rootScope.wc) {
        $timeout(function () {
          console.log('SCROLLER TO', $stateParams.sec);
          $("html, body")
          //.delay(1000)
            .animate({scrollTop: $('#' + $stateParams.sec).offset().top}, 1000);
        }, 1500);
      }
      if (!$stateParams.sec && $rootScope.wc) {
        console.log(' SCROLLER TO TOP', $stateParams.sec);
        $("html, body").animate({scrollTop: 0}, 500);
      }*/
      $timeout(function () {
        console.log('SCROLLER TO', sec);
        $("html, body")
          .animate({scrollTop: $('#' + sec).offset().top}, 1000);
      }, 100);
    };
    $rootScope.current= 1;
    $rootScope.GoNext = function(){
      var next = 1;
      if($rootScope.current == 1 || $rootScope.current == 2){
        console.log('cambia gonext 1 o 2');
         next = $rootScope.current+1;
      }
      console.log('cambia gonext', next);
      $rootScope.stateGo('home','s'+next);
    };

    console.log('document.documentElement.scrollTop', document.documentElement.scrollTop);
    $rootScope.showLoader = true;
    $timeout(function () {
      $rootScope.showLoader = false;
    }, 3000);

    //AUTO EXECUTE ON ROUTE CHANGE OR LOAD
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {

      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.menu = false;
      $rootScope.currentState = $state.current.name;
      if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        console.log('language', $stateParams.lan);
        $rootScope.language = $stateParams.lan;
      }
      else {
        $rootScope.language = 'es';
       $state.go('home', {lan: 'es'});
      }
      if ($rootScope.currentState != 'home' && !$stateParams.sec) {
        var stateFix = $rootScope.currentState.split('fix');
        console.log('detect incomplete route', stateFix);
        $state.go(stateFix[0], {lan: $rootScope.language, sec: ''});
      }
      //$rootScope.setSessionParam('language', value);
      //$rootScope.showLoader = true;

      //GET RESTAPI CONTENTS
      ContentService.webcontent($rootScope.currentState,{})
        .success(function (res) {
          if (res.status) {
            $rootScope.wcdata = res.result;
            console.log('webcontent', res, res.result.data);
            //GET CURRENT SECTION TO RENDER IN MAIN-TEMPLATE
            $rootScope.getCurrentSection('home');
            //GET CONTACT DATA
            //CONSTRUCT SUB MENUS LIST
            //$rootScope.constructMenu();
            //AUTOMATIC SCROLL BEFORE WEB CONTENTS IS LOADED
            /*$rootScope.scroller();
            if ($rootScope.currentState != 'home') {
              $timeout(function () {
                $rootScope.showLoader = false;
              }, 500);
            }
            var scrollPos = document.documentElement.scrollTop;
            $("html, body").animate({scrollTop: scrollPos + 1}, 500);*/
            //LOADER
            /*$rootScope.getImageArray = function (source, target) {
              var imageArray = [];
              angular.forEach(source, function (value, key) {
                if (value[target]) {
                  imageArray.push($rootScope.api + value[target]);
                }
              });
              return imageArray;
            };
            if ($rootScope.currentState == 'home') {
              var imageArray = $rootScope.getImageArray($rootScope.wc.Webhomecarousel, 'image');
              ImageLoader.loadImages(imageArray).then(function (loadedStrings) {
                $rootScope.imageStringsList = loadedStrings;
                console.log($rootScope.imageStringsList);
                new WOW().init();
                $rootScope.showLoader = false;
                //PROMO
                if ($rootScope.wc.Gpromo) {
                  $timeout(function () {
                    $rootScope.showModal('modalpromo')
                  }, 2000);
                }

              });
            }*/
          }
        });

      //GET CURRENT LANGUAGE
    /*  ($rootScope.getSessionParam('language')) ?
        $rootScope.language = $rootScope.getSessionParam('language') : $rootScope.language = 'es';*/
    });


  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/home');
    $stateProvider
      .state('home', {
        url: '/:lan',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/singlepage/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('home2', {
        url: '/:lan/home/:sec',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/singlepage/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      });

    $urlRouterProvider.otherwise('/es');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontendApp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider, $authProvider, localStorageServiceProvider) {
    /*// Set the default quality
    $colorThiefProvider.setDefaultQuality(50);

    // Set the default palette color count
    $colorThiefProvider.setDefaultColorCount(5);

    // Set wether to return arrays (ColorThief's default) or
    // objects like {r: 242, g: 124, b: 91} (false by default).
    $colorThiefProvider.setReturnObjects(true);*/

    // Login
    //$authProvider.loginUrl = 'https://www.seboing.com/restapi/api/authenticate';
    $authProvider.loginUrl = 'http://localhost:8000/api/authenticate';
    localStorageServiceProvider
      .setPrefix('adminApp')
      .setStorageType('sessionStorage')
      .setNotify(true, true);

    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
    new WOW().init();
  }

})();

angular.module("frontendApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/views/header.html","<div class=\"menu-header\"><div class=\"header\"><div class=\"navbar navbar-default\" role=\"navigation\"><img class=\"brand\" src=\"../assets/images/marca-techwise-01.png\" alt=\"techwise\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-ng-init=\"navCollapsed = true\" data-ng-click=\"navCollapsed = !navCollapsed\" data-toggle=\"collapse\" data-target=\"#js-navbar-collapse\"><i class=\"fas fa-bars\"></i></button></div><ul class=\"nav navbar-nav lan-link\"><li><p><a href=\"\" data-ng-click=\"$root.changeLanguage(\'es\',\'home\')\" data-ng-class=\"{\'active\':$root.language==\'es\'}\" class=\"lan\">ES</a> | <a href=\"\" data-ng-click=\"$root.changeLanguage(\'en\',\'home\')\" data-ng-class=\"{\'active\':$root.language==\'en\'}\" class=\"lan\">EN</a></p></li></ul><ul class=\"nav navbar-nav section-link\"><li><a data-ng-click=\"$root.stateGo(\'home\',\'s1\')\" data-ng-class=\"{\'active\':$root.current==1}\" class=\"index-link\">01</a></li><li><a data-ng-click=\"$root.stateGo(\'home\',\'s2\')\" data-ng-class=\"{\'active\':$root.current==2}\" class=\"index-link\">02</a></li><li><a data-ng-click=\"$root.stateGo(\'home\',\'s3\')\" data-ng-class=\"{\'active\':$root.current==3}\" class=\"index-link\">03</a></li></ul><ul class=\"nav navbar-nav social-link\"><li class=\"mobile\"><a target=\"_blank\" href=\"https://api.whatsapp.com/send?phone=591{{$root.transl($root.wc.webcontent[6].content)}}\" class=\"social-icon\"><i class=\"fab fa-whatsapp\"></i></a></li><li><a href=\"{{$root.transl($root.wc.webcontent[8].content)}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-facebook-f\"></i></a></li><li><a href=\"{{$root.transl($root.wc.webcontent[10].content)}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-linkedin-in\"></i></a></li><li><a href=\"{{$root.transl($root.wc.webcontent[9].content)}}\" target=\"_blank\" class=\"social-icon\"><i style=\"font-weight: bold\" class=\"fab fa-instagram\"></i></a></li></ul></div></div></div>");
$templateCache.put("app/views/loader.html","<div windowheight=\"\" class=\"loader-wrapper\"><div loader=\"\" class=\"load up\"><img class=\"wow fadeIn brand\" src=\"../assets/images/marca-techwise-01.png\" alt=\"techwise\"><div class=\"load-bar\"></div></div><div loader=\"\" class=\"load down\"><div class=\"load-bar\"></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/modals/modalcontact.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><a class=\"close-button\" data-ng-click=\"$root.closeModal()\"><i class=\"fas fa-times\"></i></a><div class=\"form-wrapper\"><form ng-submit=\"$root.sendForm(3, $root.formData, true)\"><h3 class=\"form-title {{$root.gustuTheme}}\">{{$root.sT(\'Contáctenos\',\'Contact us\')}}</h3><div class=\"input-row\"><input type=\"text\" data-ng-model=\"$root.formData.name\" required=\"\" placeholder=\"{{$root.sT(\'Nombre *\',\'Name *\')}}\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"email\" data-ng-model=\"$root.formData.email\" required=\"\" placeholder=\"{{$root.sT(\'Correo electrónico *\',\'Email *\')}}\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" data-ng-model=\"$root.formData.phone\" placeholder=\"{{$root.sT(\'Teléfono\',\'Phone\')}}\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" data-ng-model=\"$root.formData.enterprise\" placeholder=\"{{$root.sT(\'Empresa\',\'Enterprise\')}}\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" data-ng-model=\"$root.formData.area\" placeholder=\"{{$root.sT(\'Área de interes\',\'Area of ​​interest\')}}\" class=\"form-control\"></div><div class=\"input-row\"><textarea name=\"\" data-ng-model=\"$root.formData.message\" placeholder=\"{{$root.sT(\'Mensaje\',\'Message\')}}\" class=\"form-control\"></textarea></div><div class=\"input-row\"><button style=\"margin-top: 20px; margin: 20px auto; display: block; float: none;\" type=\"submit\" class=\"button button--antiman button--round-l button--text-medium\">{{$root.sT(\'Enviar\',\'Send\')}}</button></div></form></div></div></div>");
$templateCache.put("app/views/singlepage/aboutus.html","<div class=\"row section s2\" customheight=\"\" id=\"s2\" data-ng-style=\"{\'background\': \'url(\' + $root.api+$root.wc.webcontent[2].file + \')\'}\"><div class=\"us-wrapper\"><h1 class=\"sec-title\">02 <span>{{$root.transl($root.wc.webcontent[1].content)}}</span></h1><div class=\"watcher\" data-in-view=\"($inview)?$root.current = 2:\'\'\"></div><div class=\"content\" customheight=\"\" minus=\"240\"><div class=\"block-aboutus left wow fadeIn\" data-wow-delay=\"1s\"><img ng-src=\"{{$root.api+$root.wc.websection[6].image1}}\" alt=\"\"></div><div class=\"block-aboutus right\"><h2 class=\"wow fadeInLeft\">{{$root.transl($root.wc.websection[6].title1)}}</h2><p class=\"wow fadeInLeft\" data-ng-bind-html=\"$root.transl($root.wc.websection[6].content1)\"></p><button data-ng-click=\"$root.showInner($root.wc.websection[6])\" class=\"wow fadeInLeft button button--antiman button--round-l button--text-medium\"><i style=\"color:white\" class=\"fas fa-chevron-left\"></i> {{$root.sT(\'Ver más\', \'see more\')}}</button></div></div></div></div>");
$templateCache.put("app/views/singlepage/contact.html","<div class=\"row section s3 contact-wrapper\" id=\"s3\" customheight=\"\"><div data-ng-if=\"$root.particles\" particles-drv2=\"\"></div><div customheight=\"\" class=\"block left\"><h1 class=\"sec-title\">03 <span>{{$root.transl($root.wc.webcontent[3].content)}}</span></h1><div class=\"watcher\" data-in-view=\"($inview)?$root.current = 3:\'\'\"></div><div class=\"wow fadeInLeft cont-info\" data-wow-delay=\"0.5s\"><h3 class=\"subtitle\">{{$root.sT(\'Dirección\',\'Address\')}}</h3><p>{{$root.transl($root.wc.webcontent[4].content)}}</p></div><div class=\"wow fadeInLeft cont-info\" data-wow-delay=\"0.5s\"><h3 class=\"subtitle\">{{$root.sT(\'Teléfono\',\'Phone\')}}</h3><p class=\"trigguer\"><a href=\"tel:2 2441121\">(+591) {{$root.transl($root.wc.webcontent[5].content)}}</a></p></div><div class=\"wow fadeInLeft cont-info\" data-wow-delay=\"0.5s\"><h3 class=\"subtitle\">Whatsapp</h3><p class=\"trigguer\"><a href=\"https://api.whatsapp.com/send?phone=591{{$root.transl($root.wc.webcontent[6].content)}}\">(+591) {{$root.transl($root.wc.webcontent[6].content)}}</a></p></div><div class=\"wow fadeInLeft cont-info\" data-wow-delay=\"0.5s\"><h3 class=\"subtitle\">{{$root.sT(\'Correo electrónico\',\'Email\')}}</h3><p class=\"trigguer\"><a data-ng-click=\"$root.sendMail( $root.transl($root.wc.webcontent[7].content),\'Contacto Techwise Solutions\',\'\')\">{{$root.transl($root.wc.webcontent[7].content)}}</a></p></div><div class=\"wow fadeInLeft cont-info t2\" data-wow-delay=\"0.5s\"><button data-ng-click=\"$root.showModal(\'modalcontact\');\" class=\"button button--antiman button--round-l button--text-medium\">{{$root.sT(\'Contáctenos\',\'Contact us\')}}</button></div><div class=\"wow fadeInLeft cont-info social-wrapper\"><a href=\"{{$root.transl($root.wc.webcontent[8].content)}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-facebook-f\"></i></a> <a href=\"{{$root.transl($root.wc.webcontent[10].content)}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-linkedin-in\"></i></a> <a href=\"{{$root.transl($root.wc.webcontent[9].content)}}\" target=\"_blank\" class=\"social-icon\"><i style=\"font-weight: bold\" class=\"fab fa-instagram\"></i></a></div></div><div equalheight=\"\" full=\"true\" targetclass=\"block\" class=\"block right\"><ng-map data-ng-if=\"$root.wcdata\" equalheight=\"\" full=\"true\" targetclass=\"block\" center=\"{{$root.wcdata.Webconfig[0].value}},{{$root.wcdata.Webconfig[1].value}}\" zoom=\"16\" styles=\'[ { \"elementType\": \"geometry\", \"stylers\": [ { \"color\": \"#1d2c4d\" } ] }, { \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#8ec3b9\" } ] }, { \"elementType\": \"labels.text.stroke\", \"stylers\": [ { \"color\": \"#1a3646\" } ] }, { \"featureType\": \"administrative\", \"elementType\": \"geometry\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"administrative.country\", \"elementType\": \"geometry.stroke\", \"stylers\": [ { \"color\": \"#4b6878\" } ] }, { \"featureType\": \"administrative.land_parcel\", \"elementType\": \"labels\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"administrative.land_parcel\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#64779e\" } ] }, { \"featureType\": \"administrative.province\", \"elementType\": \"geometry.stroke\", \"stylers\": [ { \"color\": \"#4b6878\" } ] }, { \"featureType\": \"landscape.man_made\", \"elementType\": \"geometry.stroke\", \"stylers\": [ { \"color\": \"#334e87\" } ] }, { \"featureType\": \"landscape.natural\", \"elementType\": \"geometry\", \"stylers\": [ { \"color\": \"#023e58\" } ] }, { \"featureType\": \"poi\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"poi\", \"elementType\": \"geometry\", \"stylers\": [ { \"color\": \"#283d6a\" } ] }, { \"featureType\": \"poi\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#6f9ba5\" } ] }, { \"featureType\": \"poi\", \"elementType\": \"labels.text.stroke\", \"stylers\": [ { \"color\": \"#1d2c4d\" } ] }, { \"featureType\": \"poi.park\", \"elementType\": \"geometry.fill\", \"stylers\": [ { \"color\": \"#023e58\" } ] }, { \"featureType\": \"poi.park\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#3C7680\" } ] }, { \"featureType\": \"road\", \"elementType\": \"geometry\", \"stylers\": [ { \"color\": \"#304a7d\" } ] }, { \"featureType\": \"road\", \"elementType\": \"labels.icon\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"road\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#98a5be\" } ] }, { \"featureType\": \"road\", \"elementType\": \"labels.text.stroke\", \"stylers\": [ { \"color\": \"#1d2c4d\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"geometry\", \"stylers\": [ { \"color\": \"#33a1bb\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"geometry.stroke\", \"stylers\": [ { \"color\": \"#255763\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#b0d5ce\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"labels.text.stroke\", \"stylers\": [ { \"color\": \"#023e58\" } ] }, { \"featureType\": \"road.local\", \"elementType\": \"labels\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"transit\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"transit\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#98a5be\" } ] }, { \"featureType\": \"transit\", \"elementType\": \"labels.text.stroke\", \"stylers\": [ { \"color\": \"#1d2c4d\" } ] }, { \"featureType\": \"transit.line\", \"elementType\": \"geometry.fill\", \"stylers\": [ { \"color\": \"#283d6a\" } ] }, { \"featureType\": \"transit.station\", \"elementType\": \"geometry\", \"stylers\": [ { \"color\": \"#3a4762\" } ] }, { \"featureType\": \"water\", \"elementType\": \"geometry\", \"stylers\": [ { \"color\": \"#0e1626\" } ] }, { \"featureType\": \"water\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#4e6d70\" } ] } ]\'><marker position=\"{{$root.wcdata.Webconfig[0].value}},{{$root.wcdata.Webconfig[1].value}}\" title=\"Mitru Sur\" icon=\"{ url:\'../assets/images/marker.png\', scaledSize:[35,50], origin: [0,0], anchor: [16,40] }\"></marker></ng-map></div></div>");
$templateCache.put("app/views/singlepage/innerview.html","<div class=\"innerview-wrapper\" data-ng-class=\"{\'show\':$root.innerview}\" windowheight=\"\"><a href=\"\" class=\"btn-close\" data-ng-click=\"$root.showInner()\"><i class=\"fas fa-chevron-right\"></i></a><div class=\"mobile-button\" data-ng-click=\"$root.showInner()\"><a href=\"\"><i class=\"fas fa-chevron-right\"></i> {{$root.sT(\'Atrás\',\'Back\')}}</a></div><div class=\"inner left\" data-ng-if=\"$root.innerview == true\"><ng-owl-carousel class=\"owl-theme images-carousel\" owl-items=\"$root.picked.websectionslider\" owl-properties=\"ini.properties\" owl-ready=\"ready($api)\"><div class=\"item\" customheight=\"\" data-ng-repeat=\"item in $root.picked.websectionslider track by $index\" data-ng-style=\"{\'background\': \'url(\' + $root.api + item.image + \')\'}\"></div></ng-owl-carousel></div><div class=\"inner right\" customheight=\"\" ng-swipe-right=\"$root.showInner()\"><h1>{{$root.transl($root.picked.title2)}}</h1><div class=\"social-wrapper\"><a class=\"share-text\"><i class=\"fas fa-share-alt\"></i></a> <a socialshare=\"\" socialshare-provider=\"facebook\" socialshare-text=\"Techwise Solutions\" socialshare-url=\"{{$root.picked.urlshare}}\" class=\"social-icon\"><i class=\"fab fa-facebook-f\"></i></a> <a socialshare=\"\" socialshare-provider=\"linkedin\" socialshare-text=\"Techwise Solutions\" socialshare-url=\"{{$root.picked.urlshare}}\" class=\"social-icon\"><i class=\"fab fa-linkedin-in\"></i></a> <a socialshare=\"\" socialshare-provider=\"twitter\" socialshare-text=\"Techwise Solutions\" socialshare-hashtags=\"{{$root.picked.tags}}\" socialshare-url=\"{{$root.picked.urlshare}}\" class=\"social-icon\"><i class=\"fab fa-twitter\"></i></a> <a data-ng-click=\"$root.copyToShare()\" class=\"social-icon\"><i class=\"fas fa-link\"></i></a><input type=\"text\" style=\"position: fixed; z-index: -1000;bottom: 100%;\" data-ng-model=\"$root.picked.urlshare\" id=\"myInput\"></div><img data-ng-if=\"$root.picked.image2\" ng-src=\"{{$root.api+$root.picked.image2}}\" alt=\"\" style=\"max-width:100%;margin-bottom: 30px\"><div class=\"content-block\" data-ng-bind-html=\"$root.transl($root.picked.content2)\"></div><div data-ng-repeat=\"g in $root.picked.websectiongal\"><h3>{{$root.transl(g.title)}}</h3><div class=\"content-block\" data-ng-if=\"$root.transl(g.content)!=\'\'\" data-ng-bind-html=\"$root.transl(g.content)\"></div><div class=\"gallery\"><img data-ng-repeat=\"item in g.websectiongalitem\" ng-src=\"{{$root.api+item.image}}\" alt=\"{{item.name}}\"></div></div><div data-ng-repeat=\"v in $root.picked.websectionvid\"><h3>{{$root.transl(v.title)}}</h3><div class=\"content-block\" data-ng-if=\"$root.transl(v.content)!=\'\' && $root.picked.websectionvid.length>0\" data-ng-bind-html=\"$root.transl(v.content)\"></div><div data-ng-if=\"$root.picked\" class=\"gallery video\" data-ng-repeat=\"vid in v.websectionviditem\"><div class=\"video\" my-youtube=\"\" code=\"vid.video\"></div></div></div><button data-ng-click=\"$root.showModal(\'modalcontact\');\" class=\"button button--antiman button--round-l button--text-medium\">{{$root.sT(\'Contáctenos\',\'Contact us\')}}</button></div></div>");
$templateCache.put("app/views/singlepage/innerview2.html","<div class=\"innerview-wrapper\" data-ng-class=\"{\'show\':$root.innerview2}\" windowheight=\"\"><a href=\"\" class=\"btn-close\" data-ng-click=\"$root.showInner2()\"><i class=\"fas fa-chevron-right\"></i></a><div class=\"mobile-button\" data-ng-click=\"$root.showInner2()\"><a href=\"\"><i class=\"fas fa-chevron-right\"></i> {{$root.sT(\'Atrás\',\'Back\')}}</a></div><div class=\"inner left\"><ng-owl-carousel data-ng-if=\"$root.innerview2\" class=\"owl-theme images-carousel\" owl-items=\"ini.items\" owl-properties=\"ini.properties\" owl-ready=\"ready($api)\"><div class=\"item\" customheight=\"\" data-ng-repeat=\"item in ini.items track by $index\" data-ng-style=\"{\'background\': \'url(\' + \'/assets/images/demo2.jpg\' + \')\'}\"></div></ng-owl-carousel></div><div class=\"inner right\" customheight=\"\" ng-swipe-right=\"$root.showInner2()\"><h1>{{$root.sT(\'Conoce más sobre nuestra empresa\',\'Learn more about our company\')}}</h1><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci corporis debitis dignissimos fugit, incidunt ipsa laboriosam laudantium magnam nesciunt nobis, placeat praesentium, quaerat rem repellat sint soluta vel voluptatibus? Beatae consequuntur cumque dolore eaque, eius eos fuga fugit ipsa iusto libero necessitatibus numquam porro quos sapiente sit ullam veniam! Quis!</p><p>Accusantium alias aperiam dignissimos error iste laudantium pariatur possimus quo veniam voluptate! Autem dicta earum excepturi harum perferendis possimus sed temporibus voluptates voluptatum! A alias asperiores aspernatur assumenda commodi consectetur cupiditate debitis deserunt dignissimos dolor excepturi illum, iure necessitatibus nulla, optio provident quia quod repudiandae sint soluta totam vero voluptate.</p><h3>{{$root.sT(\'Nuestras marcas\',\'Our brands\')}}</h3><div class=\"gallery\"><img src=\"../assets/images/brands/1.png\" alt=\"img18\"> <img src=\"../assets/images/brands/2.png\" alt=\"img18\"> <img src=\"../assets/images/brands/3.png\" alt=\"img18\"> <img src=\"../assets/images/brands/4.png\" alt=\"img18\"> <img src=\"../assets/images/brands/5.png\" alt=\"img18\"> <img src=\"../assets/images/brands/6.png\" alt=\"img18\"></div><h3>Videos</h3><div class=\"gallery video\"><div class=\"video\" my-youtube=\"\" code=\"\'elLQNOGi4ZA\'\"></div><div class=\"video\" my-youtube=\"\" code=\"\'_3yWbRngyJs\'\"></div></div><button data-ng-click=\"$root.showModal(\'modalcontact\');\" class=\"button button--antiman button--round-l button--text-medium\">{{$root.sT(\'Contáctenos\',\'Contact us\')}}</button></div></div>");
$templateCache.put("app/views/singlepage/main.html","<div class=\"row\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/singlepage/innerview.html\'\"></ng-include><ng-include data-src=\"\'app/views/singlepage/innerview2.html\'\"></ng-include><ng-include data-src=\"\'app/views/singlepage/services.html\'\"></ng-include><ng-include data-src=\"\'app/views/singlepage/aboutus.html\'\"></ng-include><ng-include data-src=\"\'app/views/singlepage/contact.html\'\"></ng-include><div class=\"arrow bounce\" data-ng-if=\"!$root.innerview2 && !$root.innerview\" data-ng-click=\"$root.GoNext()\" data-ng-class=\"{\'inverse\':$root.current==3}\"><a href=\"\"><i class=\"fas fa-chevron-down\"></i></a></div></div>");
$templateCache.put("app/views/singlepage/services.html","<div class=\"row section s1\" id=\"s1\" customheight=\"\"><div data-ng-if=\"$root.particles\" particles-drv=\"\"></div><div class=\"services-wrapper\"><h1 class=\"sec-title\">01 <span>{{$root.transl($root.wc.webcontent[0].content)}}</span></h1><div class=\"watcher\" data-in-view=\"($inview)?$root.current = 1:\'\'\"></div><div class=\"content\" data-ng-if=\"!$root.showLoader\" customheight=\"\" minus=\"300\"><div class=\"sub-w\" data-ng-if=\"$root.wc\"><figure class=\"wow {{i.class}} service effect-apollo\" data-ng-repeat=\"i in $root.wc.websection | orderBy:\'id\'\" data-ng-if=\"i.id <= 6\" data-wow-delay=\"{{i.delay}}\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+i.image1 + \')\'}\"></div><figcaption><h2>{{$root.transl(i.title1)}}</h2><p data-ng-bind-html=\"$root.transl(i.content1)\"></p><button data-ng-click=\"$root.showInner(i)\" class=\"button button--antiman button--round-l button--text-medium\"><i style=\"color:white\" class=\"fas fa-chevron-left\"></i> {{$root.sT(\'Ver más\', \'see more\')}}</button></figcaption></figure></div></div></div></div>");}]);